import React, {useCallback, useEffect, useState, useRef} from "react";
import axios from "axios";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import PdfPng from '../../Assets/Pdf.png';
import { Button } from "react-bootstrap";
import { OAuthApiStartPolling, OAuthApiStopPolling } from "../../ExternalApi/OAuthApi"
import { GetUrlParameter } from "../GeneralFunctions.jsx"
import { ConfigurationApiForwardWithCustomHeaders } from "../../ExternalApi/ConfigurationApi"
import IntegrationWizardDots from "../IntegrationWizard/IntegrationWizardDots"

const DatasourceQuickBooks = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false); 
    const [mWaitingForState, SetWaitingForState] = useState("")
    const [mError, SetError] = useState("") 
    const [mOAuthWindow, SetOAuthWindow] = useState(null) 

    useEffect(() => {
        SetReady()
      }, []); 

    const UpdateDatasourceSetting = (aIdentifier, aValue) =>
    {
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aValue
        SetRepainter(!mRepainter)

        SetReady()
    }

    const SetReady = () => 
    {
        props.OnSetReady(props.IntegrationSettings.DatasourceSettings.CompanyId && props.IntegrationSettings.DatasourceSettings.RefreshToken)
    }

    async function GetTokens(aAuthorizationCode) 
    {
        const ClientId = props.IntegrationSettings.DatasourceSettings.SandBox ? "ABqzBaHcVyQgvJNvpqmraCVwnyv1aUZL6yCNGejiF6LLYib4na" : "ABJZor9XNziUZKdYv7UYM0wcjuW1yr7yZX0wrigE7IRNdjKn5S"
        const ClientSecret = props.IntegrationSettings.DatasourceSettings.SandBox ? "3GxTNLn3Y6IkH6Q1gC0bpFHvmRq4VJjGcQHq3CPZ" : "2yOENJ2GxTyjknDlKFuo5BfFJkiwhJh8duwIFIZM"
        

        let Result = await ConfigurationApiForwardWithCustomHeaders(
            props.SecurityToken, 
            "https://oauth.platform.intuit.com/oauth2/v1/tokens/bearer", 
            "POST", 
            "redirect_uri=https%3A%2F%2Fauth.cloudcti.nl%2Fwebapi%2Foauth2&grant_type=authorization_code&code=" + aAuthorizationCode, 
            "application/json", 
            "application/x-www-form-urlencoded",
            {"Authorization":"Basic " + btoa(ClientId + ":" + ClientSecret)}
            )        
        if (Result != null)
        {
            UpdateDatasourceSetting("AccessToken", Result.data.access_token)
            UpdateDatasourceSetting("RefreshToken", Result.data.refresh_token)
        }
        else
        {
            SetError("Failed to retrieve tokens")
        }

        SetWaitingForState("")
    }

    const OAuthPollResult = (aResult, aValue, aOAuthWindow) =>
    {
        try 
        { 
            if (aOAuthWindow !== null)
            {
                aOAuthWindow.close() 
                aOAuthWindow = null
                SetOAuthWindow(null)
            }
        } 
        catch {}

        if (aResult)
        {
            console.log("OAuthPollResult success: " + JSON.stringify(aValue))
            if (aValue.Code && aValue.ResponseUrl)
            {
                const CompanyId = GetUrlParameter(aValue.ResponseUrl.replaceAll("&amp;","&"),"realmId")
                UpdateDatasourceSetting("CompanyId",CompanyId)

                GetTokens(aValue.Code)
            }
            else
            {
                SetError("Failed to authenticate. No authorizationcode found")  
            }
        }
        else
        {
            console.log("OAuthPollResult error: " + JSON.stringify(aValue))  
            SetError("Failed to authenticate")          
        }
    }

    const RandomState = () => 
    {
        let Result = "client2020WEB"

        var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for ( var i = 0; i < 27; i++ ) 
        {
            Result += characters.charAt(Math.floor(Math.random() * characters.length))
        }
        
        return Result
    }

    const StartOAuth = () =>
    {
        const State = RandomState()

        const ClientId = props.IntegrationSettings.DatasourceSettings.SandBox ? "ABqzBaHcVyQgvJNvpqmraCVwnyv1aUZL6yCNGejiF6LLYib4na" : "ABJZor9XNziUZKdYv7UYM0wcjuW1yr7yZX0wrigE7IRNdjKn5S"
        const OAuthUrl = "https://appcenter.intuit.com/connect/oauth2" +
            "?scope=com.intuit.quickbooks.accounting" +
            "&client_id=" + ClientId +
            "&response_type=code" +
            "&redirect_uri=https%3A%2F%2Fauth.cloudcti.nl%2Fwebapi%2Foauth2" + 
            "&state=" + State 

        const OAuthWindow = window.open(OAuthUrl, "_blank", 'popup=yes,titlebar=0,left=' + ((screen.availWidth - 750)/2)  + ',top=' + ((screen.availHeight - 750)/2)  + ',width=750,height=750')
        SetOAuthWindow(OAuthWindow)

        OAuthApiStartPolling(State, OAuthPollResult, OAuthWindow)

        SetWaitingForState(State)
    }

    const StopOAuth = () =>
    {
        OAuthApiStopPolling()
        try 
        { 
            if (mOAuthWindow !== null)
            {
                mOAuthWindow.close() 
                SetOAuthWindow(null)
            }
        } 
        catch {}

        SetWaitingForState("")
    }

    const BrandingId = sessionStorage.getItem("BrandingId")

    const Body = props.IntegrationSettings.DatasourceSettings.RefreshToken ?
        //Authorization OK
        <div className="scriptitembody">
            {Translate("$Application connection token received succesfully").replace("$Application","QuickBooks")}
        </div> :
        (mError ?
            //Authorization failed. Show error and connect button
            <div className="scriptitembody">

                <table cellPadding="2">
                <tbody>
                    <tr>
                        <td width="30"><span className="checkbox-wrapper-13"><input type="checkbox" checked={props.IntegrationSettings.DatasourceSettings.SandBox ? "checked" : ""} onChange={evt => UpdateDatasourceSetting("SandBox",evt.target.checked)}/></span></td>
                        <td width="*">{Translate("Sandbox account")}</td>
                    </tr>
                </tbody>
                </table>
                <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button><br/>
                <div>{mError}</div>
            </div> :
            (mWaitingForState ?
                //Waiting for authorization. Show dot counter and cancel button
                <div className="scriptitembody">
                    <table cellPadding="2">
                    <tbody>
                        <tr>
                            <td width="30"><span className="checkbox-wrapper-13"><input type="checkbox" checked={props.IntegrationSettings.DatasourceSettings.SandBox ? "checked" : ""} onChange={evt => UpdateDatasourceSetting("SandBox",evt.target.checked)}/></span></td>
                            <td width="*">{Translate("Sandbox account")}</td>
                        </tr>
                    </tbody>
                    </table>
                    <Button variant="danger" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StopOAuth()} type="submit">{Translate("Cancel")}</Button><br/><br/>
                    <div>{Translate("Waiting for OAUTH verification")}<IntegrationWizardDots/></div>
                </div> :
                //Not authenticating. Show connect button
                <div className="scriptitembody">
                    <table cellPadding="2">
                    <tbody>
                        <tr>
                            <td width="30"><span className="checkbox-wrapper-13"><input type="checkbox" checked={props.IntegrationSettings.DatasourceSettings.SandBox ? "checked" : ""} onChange={evt => UpdateDatasourceSetting("SandBox",evt.target.checked)}/></span></td>
                            <td width="*">{Translate("Sandbox account")}</td>
                        </tr>
                    </tbody>
                    </table>
                    <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button>
                </div>
            )
        )

    return (
        <span>{Body}</span>
    )
}

DatasourceQuickBooks.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceQuickBooks